﻿import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { CompanyDto } from 'src/app/dtos/company-dto';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'companies',
    templateUrl: './companies.component.html',
    styleUrls: ['./companies.component.scss']
})

export class CompaniesComponent {
    search: any;
    @ViewChild("tableChild") tableChild: DataTableComponent<CompanyDto>;
  pagePath: string = "api/company/page";
  searchText: string = '';
  options = {
    columnTitles: ["COMPANY.TABLE.ID", "COMPANY.TABLE.NAME", "GENERAL.LABELS.ACTIONS"],
    columnReferences: ["id", 'name', "actions"],
    actionButtons: { edit: true, delete: true }
  };
    
    constructor(private router: Router, public dialog: MatDialog, private apiService: ApiService, private messageService: MessageService) {

    }

    goToEdit(e: any) {
        this.router.navigate(["companies/edit", e.id]);
      }

      openDeleteDialog(e: any) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '680px',
          data: {
            title: 'DIALOGS.DELETE_COMPANY.TITLE',
            body: 'DIALOGS.DELETE_COMPANY.BODY',
            cancelButtonText: "GENERAL.LABELS.CANCEL",
            confirmButtonText: "GENERAL.LABELS.DELETE",
          }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.apiService.delete('api/company/' + e.id).subscribe(data => {
              this.messageService.success("Exito", "La compañia fue removida exitosamente");
              this.tableChild.loadPage();
            }, error => {
              this.messageService.error("Error", error.message);
            })
          }
        });
      }

    searchCom(){
        this.search = {
            searchText: this.searchText
          }
          this.tableChild.firstPage();
          this.tableChild.loadPage(this.search);
    }
}